<template>
  <div v-if="visible" class="unlimited_services">
    <div class="ad-container mt-3">
      <div class="container">
        <div class="row align-items-center border-1-solid pt-5 pb-5 m-0 bg-grey-light">
          <div class="col-lg-7 col-md-7">
            <div class="services_section_thumb">
              <img :src=" getBaseUrl + 'productos/files/help/favlists-trailer.gif' " alt="">
            </div>
          </div>
          <div class="col-lg-5 col-md-5">
            <div class="unlimited_services_content">
              <h1><i class="pe-7s-star mr-2"></i>{{ $t('Listas de favoritos') }}<i class="pe-7s-star ml-2"></i></h1>
              <p v-html="$t('aviso')"></p>
              <div class="view__work">
                <router-link :to=" { name: 'user-help', params: { language: getLocale } } ">{{ $t('Más información') }} <i class="fa fa-angle-right"></i></router-link>
              </div>
            </div>            
          </div>
        </div>        
      </div>
      <div @click="close" class="btn-close" style="margin-right:15px;"><i class="fa fa-close"></i></div>
    </div>
  </div>
</template>

<i18n>
{
  "es": {
    "Listas de favoritos": "Listas de favoritos",
    "Más información": "Más información",
    "aviso": "¿<b>Realizas compras regulares</b> y necesitas seleccionar cada vez todos los productos uno por uno? A partir de ahora te lo ponemos mucho más fácil con las <b>listas de productos favoritos</b>. Crea tu lista de favoritos y selecciona cada producto especificando la cantidad. En la siguiente compra <b>con un solo click</b> podrás añadir todos los productos <b>al carrito de compra</b>."
  },
  "en": {
    "Listas de favoritos": "Favourite lists",
    "Más información": "More information",
    "aviso": "Do you <b> make regular purchases </b> and need to select all the products one by one each time? From now on we make it much easier for you with <b> favorite product lists </b>. Create your favorites lists and select each product specifying the quantity. On the next purchase <b> with a single click </b> you can add all the products <b> to the shopping cart </b>."
  }
}
</i18n>

<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex'

  export default {
    data() {
      return {
        visible: false,
      }
    },
    mounted () {
    },
    computed: {	
      ...mapGetters( ['getLocale', 'getBaseUrl'])
    },
    methods: {
      ...mapMutations(['mutateAdVisibility']),
      close() {
        this.$store.commit('mutateAdVisibility', 0)
      },
    },   
    mounted () {
    },
  }

</script>
